import React from 'react'
import PropTypes from "prop-types";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import {fetchResponseHandler} from "../../../util/FetchUtil";
import {PROP_NAME_PHONE_NUMBER} from "./PhoneInputComponent";
import {isNotBlank} from "../../../util/StringUtil";
import {trimToEmpty} from "../../../util/StringUtil";

const PROP_NAME_FIRST_NAME = "firstName";
const PROP_NAME_LAST_NAME = "lastName";
const firstNamePatternFailMessage = "First name contains an invalid character";
const lastNamePatternFailMessage = "Last name contains an invalid character";

class NameInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.firstNameChange = this.firstNameChange.bind(this);
        this.firstNameValidation = this.firstNameValidation.bind(this);
        this.lastNameChange = this.lastNameChange.bind(this);
        this.lastNameValidation = this.lastNameValidation.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        const {setFormState, metadata, data} = this.props;

        const keys = [PROP_NAME_FIRST_NAME, PROP_NAME_LAST_NAME];
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (! metadata[key]){
                setFormState({property: key, data: data[key] ? data[key] : "", metadata: {dirty: false, valid: isNotBlank(data[key])}});
            }
        }

        if(data[PROP_NAME_FIRST_NAME]){
            this.firstNameValidation(data[PROP_NAME_FIRST_NAME]);
        }
        if(data[PROP_NAME_LAST_NAME]){
            this.lastNameValidation(data[PROP_NAME_LAST_NAME]);
        }

        setupOnExtractData(this);

    }

    extractData(){
        let {data} = this.props;
        let result = {
            firstName: trimToEmpty(data[PROP_NAME_FIRST_NAME]),
            lastName: trimToEmpty(data[PROP_NAME_LAST_NAME])
        };

        return result;
    };

    firstNameChange(e) {
        const firstName = e.target.value;
        this.firstNameValidation(firstName);
    }

    firstNameValidation(firstName){
        const {setFormState, data, findCalcs, userDataInit} = this.props;
        //const firstName = e.target.value;
        let isValid = false;
        let isDirty = false;
        let message = null;

        if(firstName && firstName.trim().length > 0){
            isDirty = true;
            if (userDataInit[PROP_NAME_FIRST_NAME].firstNamePattern.test(firstName)) {
                    isValid = true;
            }else{
                message = firstNamePatternFailMessage;
            }
        }
        setFormState({property: PROP_NAME_FIRST_NAME, data: firstName, metadata: {dirty: isDirty, valid: isValid, message: message}});
        findCalcs(null, PROP_NAME_FIRST_NAME, firstName);
    }

    lastNameChange(e){
        const lastName = e.target.value;
        this.lastNameValidation(lastName);
    }

    lastNameValidation(lastName){
        const {setFormState, data, findCalcs, userDataInit} = this.props;
       //const lastName = e.target.value;
        let isValid = false;
        let isDirty = false;
        let message = null;

        if(lastName && lastName.trim().length > 0){
            isDirty = true;
            if (userDataInit[PROP_NAME_LAST_NAME].lastNamePattern.test(lastName)) {
                isValid = true;
            }else{
                message = lastNamePatternFailMessage;
            }
        }
        setFormState({property: PROP_NAME_LAST_NAME, data: lastName, metadata: {dirty: isDirty, valid: isValid, message: message}});
        findCalcs(null, PROP_NAME_LAST_NAME, lastName);
    }

    render() {
        const {data, isEditable = true, userDataInit, metadata} = this.props;
        let hasInputClassFirstName = getFormInputCssClass(metadata, PROP_NAME_FIRST_NAME);
        let hasInputClassLastName = getFormInputCssClass(metadata, PROP_NAME_LAST_NAME);


        return (
            <div className={"grid form-fields"}>
                <div className="grid__col-md-6 grid__col-sm-12">
                    <label htmlFor={PROP_NAME_FIRST_NAME}>First Name</label>
                    <input id={PROP_NAME_FIRST_NAME}
                           style={{maxHeight:'28px'}}
                           className={"text-input text-input--large" + hasInputClassFirstName}
                           value={data[PROP_NAME_FIRST_NAME]}
                           maxLength={userDataInit[PROP_NAME_FIRST_NAME].maxFirstNameLength}
                           onChange={this.firstNameChange}
                           disabled={ !isEditable ? "disabled" : null}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_FIRST_NAME) &&
                        <div className="error display--block">{metadata[PROP_NAME_FIRST_NAME].message}</div>
                    }
                </div>
                <div className={"grid__col-md-6 grid__col-sm-12"}>
                    <label htmlFor={PROP_NAME_LAST_NAME}>Last Name</label>
                    <input id={PROP_NAME_LAST_NAME}
                           style={{maxHeight:'28px'}}
                           className={"text-input text-input--large" + hasInputClassLastName}
                           value={data[PROP_NAME_LAST_NAME]}
                           maxLength={userDataInit[PROP_NAME_LAST_NAME].maxLastNameLength}
                           onChange={this.lastNameChange}
                           disabled={ !isEditable ? "disabled" : null}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_LAST_NAME) &&
                        <div className="error display--block">{metadata[PROP_NAME_LAST_NAME].message}</div>
                    }
                </div>
            </div>
        );
    }
}

NameInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
    metadata: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    findCalcs: PropTypes.func.isRequired,
    onExtractData: PropTypes.func.isRequired

}

export default NameInputComponent;

